<script setup lang="ts">
import {
  FormAutoCompleteOptionsEmits,
  FormAutoCompleteOptionsProps,
} from '@/types/form/form-auto-complete';
import { FormDropdownOption } from '@/types/form/form-dropdown/form-dropdown';

defineProps<FormAutoCompleteOptionsProps>();
const emit = defineEmits<FormAutoCompleteOptionsEmits>();
const onOptionClick = (option: FormDropdownOption) => {
  emit('option-click', option);
};
</script>

<template>
  <content-loading class="f-ac-options" :loading="loading">
    <div class="f-ac-options__content">
      <template v-for="(option, index) in options" :key="index">
        <div class="f-autocomplete__modal-option-custom" v-if="$slots.option">
          <slot name="option" :option="option" />
        </div>
        <div
          class="f-ac-options__option"
          :class="{ selected: option.value.trim() === value?.trim() }"
          @click="onOptionClick(option)"
        >
          <div class="f-ac-options__option-text" v-html="option.text" />
        </div>
      </template>
    </div>
  </content-loading>
</template>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';
.f-ac-options {
  height: calc(100vh - 200px);
  overflow-y: auto;
  @include h8;
  &::-webkit-scrollbar-track-piece {
    background: var(--item-curtain-back-color, $white);
    border-radius: 2px;
  }
  &::-webkit-scrollbar-thumb:vertical {
    background: var(--item-curtain-color, $color-primary-blue);
  }
  &__option {
    padding: 8px 16px;
    text-align: center;
    cursor: pointer;
    &.selected {
      background: $color-primary-blue;
      color: $white;
      font-weight: 500;
    }
  }
  @include tablet-landscape {
    max-height: 280px;
    height: fit-content;
  }
}
</style>
